import { render, staticRenderFns } from "./ClubPlayer.vue?vue&type=template&id=280baac4"
import script from "./ClubPlayer.vue?vue&type=script&lang=js"
export * from "./ClubPlayer.vue?vue&type=script&lang=js"
import style0 from "./ClubPlayer.vue?vue&type=style&index=0&id=280baac4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports